import { render, staticRenderFns } from "./KModal.vue?vue&type=template&id=7214ded6&scoped=true&"
import script from "./KModal.vue?vue&type=script&lang=js&"
export * from "./KModal.vue?vue&type=script&lang=js&"
import style0 from "./KModal.vue?vue&type=style&index=0&id=7214ded6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7214ded6",
  null
  
)

component.options.__file = "KModal.vue"
export default component.exports